// extracted by mini-css-extract-plugin
export default {"container":"ImageTable_container__4S0uk"};